import {Pipe, PipeTransform} from '@angular/core';
import {CplAssignment} from '../model/cpl-assignment.model';
import { AbstractControl } from '@angular/forms';
@Pipe({
    name: 'userAssignmentFilter',
    pure: false
})
export class UserAssignmentFilterPipe implements PipeTransform {
    transform(assignedUsers: Array<CplAssignment | AbstractControl>, filter: number): Array<CplAssignment | AbstractControl> {
        return assignedUsers.filter((assignedUser: CplAssignment | AbstractControl) => {
            if (assignedUser instanceof AbstractControl) {
                return assignedUser.get('Type').value === filter;
            } else {
                return assignedUser.Type === filter;
            }
            
        });
    }
}
